import { createRouter, createWebHistory } from "vue-router";
import Discovery from "@/views/discovery.vue";
import Article from "@/views/article.vue";
import Event3 from "@/views/activity/event3.vue";
import Event4 from "@/views/activity/event4.vue";
import Event5 from "@/views/activity/event5.vue";
import Coupons from "@/views/coupons.vue";
import DownloadAPK from "@/views/downloadAPK.vue";
import ExgInvCode from "@/views/exgInvCode.vue";
import ErrorLogin from "@/views/errorLogin.vue";
import Ht333first from "@/views/ht333first.vue";
import HtEvent from "@/views/htEvent.vue";
import returBlank from "@/views/returBlank.vue";
import i18n from "@/i18n";
const {t} = i18n.global

const routes = [
  {
    path: '/:lang',
    name: 'discovery',
    component: Discovery,
  },
  {
    path: '/article/:lang/:type/:id',
    name: 'article',
    component: Article,
  },
  {
    path: '/event3/:lang',
    name: 'event3',
    component: Event3,
  },
  {
    path: '/event4/:lang',
    name: 'event4',
    component: Event4,
  },
  {
    path: '/event5/:lang',
    name: 'event5',
    component: Event5,
  },
  {
    path: '/downloadapk/:lang',
    name: 'downloadAPK',
    component: DownloadAPK,
  },
  {
    path: '/coupons/:lang',
    name: 'coupons',
    component: Coupons,
  },
  {
    path: '/exginvcode/:lang/:referralCode',
    name: 'exgInvCode',
    component: ExgInvCode,
  },
  {
    path: '/errorlogin/:lang',
    name: 'errorLogin',
    component: ErrorLogin,
  },
  {
    path: '/ht333',
    name: 'ht333',
    component: Ht333first,
  },
  {
    path: '/htevent/:lang',
    name: 'htEvent',
    component: HtEvent,
  },
  {
    path: '/htfree/:lang',
    name: 'htFree',
    component: HtEvent,
    meta: {
      title: t('htEvent_text30')
    }
  },
  {
    path: '/login/:prod',
    name: 'LoginProd',
    component: returBlank,
  },
  {
    path: '/logout/:prod',
    name: 'LogoutProd',
    component: returBlank,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
